import Localbase from './localbase/localbase'

export default Localbase